export default __webpack_public_path__ + "static/media/acceY.30269069.svg";